import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { HttpStatusCode } from "axios";

import {
  SpaceReservationDetail,
  getSpaceReservationDetailById,
} from "../../../../services/spaceReservationServices";

import useFullScreenLoading from "../../../../hooks/useFullScreenLoading";

import StickyHeader from "../../../../components/Layout/StickyHeader";
import CommonButton from "../../../../components/Button";
import ReservationDetailPopup from "../../../../components/SpaceReservation/ReservationDetailPopup";
import BottomGroup from "../../../../components/Button/Group";

import spaceReservationOk from "../../../../assets/img/space-reservation-ok.png";

type Props = {};
export default function SpaceReservationWaiting(props: Props) {
  const navigate = useNavigate();
  const params = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const loadingComponent = useFullScreenLoading({ isLoading });
  const [popup, setPopup] = useState<boolean>(false);
  const [detail, setDetail] = useState<Partial<SpaceReservationDetail>>({});

  useEffect(() => {
    const loadDetail = async () => {
      if (!params.id) return;
      setIsLoading(true);
      try {
        const { status, data } = await getSpaceReservationDetailById(params.id);
        if (status === HttpStatusCode.Ok) {
          setDetail(data);
        }
      } catch (e: any) {
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };

    loadDetail();
  }, [params.id]);

  return (
    <>
      {loadingComponent}
      <div className="px-5 h-[90vh]">
        <StickyHeader title="회의실" onBackClick={() => navigate(`/view`)} />
        <div className="flex flex-col justify-between h-full">
          <div className="flex flex-col h-content justify-center">
            <div className="flex flex-col items-center gap-4">
              <img
                src={spaceReservationOk}
                alt="접수 완료"
                className="h-[100px]"
              />
              <div className="flex flex-row text-2xl font-semibold mt-5">
                접수 완료
              </div>
              <div className="flex flex-row text-gray-400 text-sm font-normal leading-[18px]">
                성공적으로 접수되었습니다.
              </div>
            </div>
          </div>
          <div className="flex flex-col py-10">
            <div className="flex flex-col px-2.5 py-5 bg-[#F7F7F7] items-center text-center text-sm font-normal leading-6 text-brand-neutral-80 whitespace-pre-line">
              {
                "샌디 매니저가 접수 확인 후\n이용 공간 승인 여부를 알려드립니다."
              }
            </div>

            <BottomGroup>
              <div className="flex flex-row gap-2 px-5">
                <CommonButton
                  className="w-full border border-gray-200 h-bottom-button rounded-none text-sm font-medium leading-18px text-brand-neutral-60"
                  variant="white"
                  title="상세보기"
                  onClick={() => setPopup(true)}
                >
                  상세 보기
                </CommonButton>
                <CommonButton
                  className="w-full border border-gray-200 h-bottom-button rounded-none text-sm font-medium leading-18px text-brand-neutral-60"
                  variant="white"
                  onClick={() =>
                    navigate(`/history/reservation/${params.id}`, {
                      state: {
                        parentUrl: `/service/space-reservation/waiting/${params.id}`,
                      },
                    })
                  }
                >
                  예약 내역 확인
                </CommonButton>
              </div>
            </BottomGroup>
          </div>
        </div>
        <ReservationDetailPopup
          isOpen={popup}
          title="접수 완료"
          detail={detail}
          onClickDetail={() => {
            navigate(
              `/service/space-reservation/detail/${detail.reservationSpaceId}/${detail.reservationDate}`,
              {
                state: {
                  parentUrl: `/service/space-reservation/waiting/${params.id}`,
                },
              }
            );
          }}
          onClose={() => {
            setPopup(false);
          }}
        />
      </div>
    </>
  );
}
